import { Briefcase, Buildings, Calendar, ReceiptItem, UserSquare } from 'iconsax-react';
import type { Icon } from 'iconsax-react';

export enum QuickAction {
  Quote = 'quote',
  Project = 'project',
  Company = 'company',
  Contact = 'contact',
  Activity = 'activity',
}

export interface QuickActionItem {
  Icon: Icon;
  id: QuickAction;
  label: string;
  shortcutKey: string;
}

export const QUICK_ACTION_ITEMS: QuickActionItem[] = [
  { id: QuickAction.Quote, label: 'New Quote', Icon: ReceiptItem, shortcutKey: 'Q' },
  { id: QuickAction.Project, label: 'New Project', Icon: Briefcase, shortcutKey: 'P' },
  { id: QuickAction.Company, label: 'New Company', Icon: Buildings, shortcutKey: 'C' },
  { id: QuickAction.Contact, label: 'New Contact', Icon: UserSquare, shortcutKey: 'N' },
  { id: QuickAction.Activity, label: 'Log Activity', Icon: Calendar, shortcutKey: 'A' },
];
